import { render } from "./addUserDetail.vue?vue&type=template&id=215dbe51&scoped=true"
import script from "./addUserDetail.vue?vue&type=script&lang=js"
export * from "./addUserDetail.vue?vue&type=script&lang=js"

import "./addUserDetail.vue?vue&type=style&index=0&id=215dbe51&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-215dbe51"]])

export default __exports__